export default function VersatilitySection() {
  return (
    <section className="bg-white overflow-hidden">
      {/* Top banner */}
      <div className="bg-[#C4F547] py-8 px-8 md:px-16 border-b-4 border-black">
        <p
          className="text-black font-black uppercase text-center"
          style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(28px, 4vw, 56px)', letterSpacing: '0.1em' }}
        >
          ONE PARTNER. FULL DIGITAL SPECTRUM.
        </p>
      </div>

      {/* Three panels */}
      <div className="grid grid-cols-1 lg:grid-cols-3 min-h-[800px]">
        {/* Panel 1: Custom Software */}
        <div className="relative overflow-hidden bg-[#FF8C42] flex flex-col justify-end min-h-[600px] lg:min-h-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20tech%20startup%20open%20plan%20office%20with%20standing%20desks%20multiple%20monitors%20lush%20indoor%20plants%20and%20warm%20yellow%20lighting%2C%20diverse%20team%20collaborating%20at%20workstations%2C%20professional%20editorial%20corporate%20photography%2C%20vibrant%20inviting%20workspace%2C%20large%20windows%20natural%20daylight%2C%20authentic%20no%20AI%20look&width=600&height=900&seq=panel-dev-v3-11&orientation=portrait"
            alt="Custom software development"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(255,140,66,0.97) 0%, rgba(255,140,66,0.75) 40%, rgba(255,140,66,0.15) 100%)' }} />
          <div className="relative z-10 p-10 md:p-14">
            <div
              className="text-white/20 font-black leading-none mb-4"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '100px', lineHeight: 1 }}
            >
              01
            </div>
            <h3
              className="text-white font-black uppercase leading-none mb-5"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 5vw, 80px)' }}
            >
              CUSTOM
              <br />
              SOFTWARE
            </h3>
            <p className="text-white/90 font-semibold text-lg leading-relaxed mb-6">
              Web apps, mobile apps, SaaS platforms — built exactly to your spec. No templates, no shortcuts.
            </p>
            <div className="flex flex-wrap gap-2">
              {['Web Apps', 'Mobile', 'SaaS', 'APIs'].map((tag) => (
                <span key={tag} className="bg-white/20 text-white font-black uppercase text-sm px-3 py-1 rounded-full" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '14px' }}>{tag}</span>
              ))}
            </div>
            <div className="mt-6 inline-block bg-white text-[#FF8C42] font-black uppercase px-6 py-3 rounded-full whitespace-nowrap"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px' }}>
              TAILOR-MADE
            </div>
          </div>
        </div>

        {/* Panel 2: IT Consulting */}
        <div className="relative overflow-hidden bg-[#1A1A1A] flex flex-col justify-end min-h-[600px] lg:min-h-0 border-l-4 border-r-4 border-[#FFD93D]">
          <img
            src="https://readdy.ai/api/search-image?query=elegant%20modern%20co-working%20lounge%20with%20high%20ceilings%20hanging%20plants%20yellow%20and%20mustard%20sofas%20wood%20furniture%20and%20living%20green%20walls%2C%20professionals%20working%20and%20meeting%2C%20warm%20natural%20sunlight%20from%20tall%20windows%2C%20architectural%20interior%20photography%2C%20vibrant%20lively%20office%20atmosphere%2C%20authentic%20real%20photo&width=600&height=900&seq=panel-consult-v3-12&orientation=portrait"
            alt="IT consulting"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(26,26,26,0.97) 0%, rgba(26,26,26,0.7) 40%, rgba(26,26,26,0.1) 100%)' }} />
          <div className="relative z-10 p-10 md:p-14">
            <div
              className="text-[#FFD93D]/20 font-black leading-none mb-4"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '100px', lineHeight: 1 }}
            >
              02
            </div>
            <h3
              className="text-white font-black uppercase leading-none mb-5"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 5vw, 80px)' }}
            >
              IT
              <br />
              <span className="text-[#FFD93D]">CONSULTING</span>
            </h3>
            <p className="text-white/80 font-semibold text-lg leading-relaxed mb-6">
              Smart tech decisions, process optimisation, and implementing the right tools for sustainable growth.
            </p>
            <div className="flex flex-wrap gap-2">
              {['Strategy', 'Audit', 'Architecture', 'Roadmap'].map((tag) => (
                <span key={tag} className="bg-[#FFD93D]/20 text-[#FFD93D] font-black uppercase text-sm px-3 py-1 rounded-full" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '14px' }}>{tag}</span>
              ))}
            </div>
            <div className="mt-6 inline-block bg-[#FFD93D] text-black font-black uppercase px-6 py-3 rounded-full whitespace-nowrap"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px' }}>
              STRATEGIC
            </div>
          </div>
        </div>

        {/* Panel 3: Digital Marketing */}
        <div className="relative overflow-hidden bg-[#1a1500] flex flex-col justify-end min-h-[600px] lg:min-h-0">
          <img
            src="https://readdy.ai/api/search-image?query=creative%20open-plan%20agency%20office%20with%20exposed%20brick%20industrial%20ceiling%20colourful%20pendant%20lights%20hanging%20plants%20and%20wall%20murals%2C%20young%20diverse%20team%20working%20on%20laptops%20and%20having%20animated%20discussions%20around%20tables%2C%20warm%20cheerful%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20bright%20natural%20light%2C%20genuine%20candid%20workplace%20moment&width=600&height=900&seq=panel-mkt-v3-13&orientation=portrait"
            alt="Digital marketing"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(26,21,0,0.97) 0%, rgba(26,21,0,0.7) 40%, rgba(26,21,0,0.1) 100%)' }} />
          <div className="relative z-10 p-10 md:p-14">
            <div
              className="text-[#FFD93D]/20 font-black leading-none mb-4"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '100px', lineHeight: 1 }}
            >
              03
            </div>
            <h3
              className="text-[#FFD93D] font-black uppercase leading-none mb-5"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 5vw, 80px)' }}
            >
              DIGITAL
              <br />
              <span className="text-white">MARKETING</span>
            </h3>
            <p className="text-white/80 font-semibold text-lg leading-relaxed mb-6">
              SEO, paid ads, social media, content strategy — we help your product find and grow its audience.
            </p>
            <div className="flex flex-wrap gap-2">
              {['SEO', 'PPC', 'Social', 'Content'].map((tag) => (
                <span key={tag} className="bg-white/10 text-white font-black uppercase text-sm px-3 py-1 rounded-full" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '14px' }}>{tag}</span>
              ))}
            </div>
            <div className="mt-6 inline-block bg-[#FFD93D] text-black font-black uppercase px-6 py-3 rounded-full whitespace-nowrap"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px' }}>
              HIGH-IMPACT
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
